export default __webpack_public_path__ + "static/media/ststephen.cce57f55.jpg";